import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { SharedModule } from '../shared/shared.module';
import { PerformanceComponent } from './performance/performance.component';


@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
  ],

  declarations: [
  
    PerformanceComponent
  ],

  entryComponents: [
    
  ],

  providers: [
  ],

  exports: [
    PerformanceComponent
  ]

})
export class DashboardModule { }